













import Vue from 'vue'
import VideoPlayIcon from '@/components/VideoPlayIcon.vue'

export default Vue.extend({
  name: 'MediaPreview',
  components: {
    VideoPlayIcon
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    mediaUrl: {
      type: String,
      default: null
    },
    mediaType: {
      type: String,
      default: '',
      validator: (prop: string) => {
        return /(photo|video)/.test(prop) || prop === ''
      }
    },
    onClose: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      isActive: false,
      video: null,
      isVisibleVideoIcon: true
    }
  },
  computed: {
    isPhotoMedia(): boolean {
      return this.mediaType === 'photo'
    },
    isVideoMedia(): boolean {
      return this.mediaType === 'video'
    }
  },
  watch: {
    active(val: boolean) {
      this.isActive = val
    },
    async mediaType(val: string) {
      if (val) {
        if (this.isVideoMedia) {
          await this.$nextTick()
          this.video = this.$refs.videoGuard['$el']
          if (this.video) {
            this.video.addEventListener('play', this.onPlayVideo, false)
            this.video.addEventListener('pause', this.onPauseVideo, false)
          }
        }
      } else {
        this.clearVideo()
      }
    }
  },
  destroyed() {
    this.clearVideo()
  },
  methods: {
    _onClose() {
      this.isActive = false
      this.$emit('update:active', false)
      if (typeof this.onClose === 'function') {
        this.onClose()
      }
    },

    onPlayVideo() {
      this.isVisibleVideoIcon = false
    },

    onPauseVideo() {
      this.isVisibleVideoIcon = true
    },

    clearVideo() {
      if (!this.video) {
        return
      }
      this.video.removeEventListener('play', this.onPlayVideo, false)
      this.video.removeEventListener('pause', this.onPauseVideo, false)
      this.video = null
    }
  }
})
